module.exports = __webpack_public_path__ + "static/funnels-7b1a8439f868a4054cc11945d8769414.png";